<p>chat-single-floating works!</p>
